import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import BlankSpacePlaceholder from '~/components/BlankSpacePlaceholder/BlankSpacePlaceholder';
import Translate from '~/components/Translate/Translate';
import Lottie from '~/containers/Lottie/Lottie';
import User from '~/models/User';

import pageNotFound from '../../public/img/animatedSVG/pageNotFound';
import { checkFeatureFlag } from '../../modules/helpers';

function PageNotFound({ className = 'background-5' }) {
    const defaultOptions = {
        animationData: pageNotFound
    };

    const canSeeSecOpsPage = checkFeatureFlag('full_csoar');

    return (
        <BlankSpacePlaceholder
            img={<Lottie options={defaultOptions} width={300} height={300} />}
            title={<Translate message="Page not Found" />}
            className={className}
            actions={
                <Link to="/" className="text-uppercase">
                    <h5>
                        {canSeeSecOpsPage ? (
                            <Translate message="Go to secops" />
                        ) : (
                            <Translate message="Go back" />
                        )}
                    </h5>
                </Link>
            }
        />
    );
}

PageNotFound.propTypes = {
    className: PropTypes.string
};

export default PageNotFound;
